<template>
  <div class="star-widget">
    <div class="lds-ring pl-8 mr-4" v-if="loading || !currentRating">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
    <div v-else>
      <div class="star-widget__header">
        <p>Total Avg: {{ currentRating.avg_rating }} out of 5</p>
        <p class="star-widget__total">
          {{ currentRating.total_count }} global ratings
        </p>
      </div>
      <vue-apex-charts
        class="star-widget__graph"
        type="bar"
        height="180"
        :options="options"
        :series="[
          {
            name: 'Ratings',
            data: [
              currentRating['5'],
              currentRating['4'],
              currentRating['3'],
              currentRating['2'],
              currentRating['1'],
            ],
          },
        ]"
      ></vue-apex-charts>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'RatingWidget',
  components: {
    VueApexCharts,
  },
  props: {
    content_id: {
      type: String,
      required: true,
    },
    content_type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: {
        chart: {
          type: 'bar',
          id: 'stars-chart',
          fontFamily: 'Montserrat", Helvetica, Arial, sans-serif',
        },
        xaxis: {
          categories: ['5 stars', '4 stars', '3 stars', '2 stars', '1 stars'],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value
            },
          },
        },
        dataLabels: {
          formatter: function (val, { w }) {
            const total = w.globals.seriesTotals
            return total && total[0]
              ? ((val / total) * 100).toFixed(2) + '%'
              : ''
          },
          offsetX: 40,
          style: {
            colors: ['#000'],
            fontSize: '11px',
          },
        },
        colors: ['#ed8a19'],
      },
      starsConfig: {
        fullStarColor: '#ed8a19',
        emptyStarColor: '#737373',
        starWidth: 10,
        starHeight: 10,
      },
      loading: false,
    }
  },
  computed: {
    ...mapState({
      contentRatings: (state) => state.ratings.ratingsByContent,
      instructorRatings: (state) => state.ratings.ratingsByInstructor,
    }),
    currentRating() {
      switch (this.content_type) {
        case 'course':
        case 'learning-path':
          return this.contentRatings[this.content_id]
        case 'instructor':
          return this.instructorRatings[this.content_id]
        default:
          return null
      }
    },
  },
  methods: {
    ...mapActions('ratings', ['getRatingSummary']),
  },
  async mounted() {
    if (!this.currentRating) {
      this.loading = true
      const searchParamKey =
        this.content_type === 'instructor' ? 'instructor' : 'model_id'
      await this.getRatingSummary({
        [searchParamKey]: this.content_id,
      })
      this.loading = false
    }
  },
}
</script>
<style lang="scss">
.star-widget {
  min-width: 250px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  display: block;
  background: white;
  box-shadow: 0 2.8px 2.2px rgba(0, 0, 0, 0.034),
    0 6.7px 5.3px rgba(0, 0, 0, 0.048), 0 12.5px 10px rgba(0, 0, 0, 0.06),
    0 22.3px 17.9px rgba(0, 0, 0, 0.072), 0 41.8px 33.4px rgba(0, 0, 0, 0.086),
    0 100px 80px rgba(0, 0, 0, 0.12);
  background: white;
  padding: 10px 20px;
  border-radius: 5px;
  position: absolute;
  z-index: 9999;
}
</style>
